module.exports = __webpack_public_path__ + "static/media/bg_all.44a71780.svg";